/**
 * Created by Ning Jiang on 2021-05-27.
 */

import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {DDay} from "../DDay";

export class BlitzKriegWinPresentation implements FlowStatePresentation {

    constructor() {}

    public async start(flowStateController:FlowStateController) {
        await DDay.winPresentations.startInLine(flowStateController);
        flowStateController.finish();
    }
}
